import { CheckException } from './check-exception';

export class CheckExceptionAggregate {
    constructor(data: CheckException[], totalCount: number, toDecideCount: number) {
        this.data = data;
        this.totalCount = totalCount;
        this.toDecideCount = toDecideCount;
    }

    public data: CheckException[];

    public totalCount: number;

    public toDecideCount: number;
}
